import { render, staticRenderFns } from "./msgList.vue?vue&type=template&id=0d92cd74&scoped=true&"
import script from "./msgList.vue?vue&type=script&lang=js&"
export * from "./msgList.vue?vue&type=script&lang=js&"
import style0 from "./msgList.css?vue&type=style&index=0&id=0d92cd74&prod&scoped=true&lang=css&"
import style1 from "./msgList.vue?vue&type=style&index=1&id=0d92cd74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d92cd74",
  null
  
)

export default component.exports